// extracted by mini-css-extract-plugin
export default {"container":"Renewal_container__cJC-x"};